// CLASS token shapes
// Default: BRACKETED (`some-class` -> `some-class-[value]`)
// ALIASED: value maps to a full class via `tokens` (`some-value` -> `some-class`)
const classTokenFormats = {
  BRACKETED: 'bracketed',
  ALIASED: 'aliased',
};

export { classTokenFormats };
